export default [
  {
    title: 'Transparent and secure <br />data management',
    desc:
      "Our customers' data belongs to them. It is stored in our data centers through a strict encryption process. No data can be accessed without customer's consent under any circumstances. DATA CENTER GAK manages your data in a transparent and secure way.",
  },
  {
    title: 'The perfect service <br />continuity created by the best security systems',
    desc:
      'DATA CENTER GAK puts data protection on the highest priority. We run a security system built by top security experts with extensive experience and knowledge of global security threats. With this, secure data protection and perfect service continuity are ensured.',
  },
  {
    title: 'Strict compliance <br />with regulations',
    desc: 'DATA CENTER GAK strictly abides by any related legal guidelines for the data protection that is more secure and transparent.',
  },
  {
    title: 'Value creation <br />for the future',
    desc:
      'Data protection activities are a required condition for broadening individual, regional, and national competitiveness and creating a sustainable society. DATA CENTER GAK leads the way in creating sustainable values with the data sovereignty.',
  },
];
